import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pat-payment-panel-adyen-cb',
  templateUrl: './pat-payment-panel-adyen-cb.component.html',
})
export class PatPaymentPanelAdyenCbComponent {
  @Input() clientKey?: string;
  @Input() googlePayMerchantName?: string;
  @Input() googlePayMerchantId?: string;
  @Input() googlePayGatewayMerchantId?: string;
  @Input() paymentMethodCbAvailable?: string;
  @Input() paymentMethodPaypalAvailable = false;
  @Input() paymentMethodGooglePayAvailable = false;
  @Input() paymentMethodApplePayAvailable = false;
}
